import { httpsCallable } from 'firebase/functions'
import { functions } from '../../../backend/functions/functions'

export const contactUs = httpsCallable(functions, 'contactUs')
